import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CaseCreateForm from "forms/case-create";
import { Row, Col, Drawer, Button, Modal, message } from "antd";
import { CaseEntryRecord } from "records/index";
import { updateCaseMeta, resetCaseMeta, uploadCompanyLedger } from "store/actions";
import "styles/drawer.css";
import { STATE_STATUS } from "constants/index";
import { fetchCaseLedgerMasters }  from "services/case-service";
import { CompanyService } from "services";
import { UnderwritingService } from "services/index";
import UploadLedgerForm from "forms/upload-ledger-form";
// import { STATE_STATUS } from "constants/index";

class CaseMetaInfo extends React.Component {
    state = {
        ledger_masters: [],
        gstin: null,
        status: STATE_STATUS.UNFETCHED,
        caseEntryRecord: new CaseEntryRecord(),
        openModal: false
    }

    formRef = React.createRef();
    hideDrawer = () => {
        const { 
            history, 
            location: {
                pathname, 
                state: locationState
            }
        } = this.props;
        this.props.resetCaseMeta();
        history.replace(pathname, {
            ...locationState,
            case_meta: null
        });

    }

    componentDidMount() {
        if(this.props.caseId !== this.props.caseMeta.get("caseId")) {
            this.props.resetCaseMeta(this.props.caseId);
        }
    }

    componentDidUpdate(prevProps) {
        if(this.props.caseId !== this.props.caseMeta.get("caseId")) {
            this.props.resetCaseMeta(this.props.caseId);
        }
        if(
            this.state.status === STATE_STATUS.UNFETCHED && 
            this.props.company && 
            this.props.company.gstin &&
            this.props.caseDetail
        ) {
            this.fetchLedgerMastersAndGSTIN();
        }
        if(this.state.status === STATE_STATUS.FETCHED) {
            this.createCaseEntryRecord();
        }
        if(this.props.company && this.props.company.gstin && this.props.caseDetail && this.props.uploadedLedgers) {
            this.fetchLedgerMastersAndGSTIN();
        }
        if(this.props.caseMeta.get("status") === STATE_STATUS.UPDATED && prevProps.caseMeta.get("status") === STATE_STATUS.UPDATING) {
            this.setState({
                status: STATE_STATUS.UNFETCHED
            });
        }
    }

    fetchLedgerMastersAndGSTIN() {
        const  { company, caseDetail } = this.props;
        this.setState({
            status: STATE_STATUS.FETCHING
        }, async () => {
            let { data: ledger_masters } = await fetchCaseLedgerMasters(caseDetail.id);
            const { data: gstin_ledger_masters } = await UnderwritingService.getSupplyChainListByGSTIN(company.gstin);
            let parsedGstin = null;
            try{
                const { data: gstin } = await CompanyService.parseGSTIN(company.gstin);
                parsedGstin = gstin;
            }
            catch (error){
                message.error(error && Object.values(error)[0] || "Invalid GSTIN");
            }
            gstin_ledger_masters.map(_ => {
                if(!ledger_masters.find(__ => __.ledger_analysis && __.ledger_analysis.id === _.id || _.id === __.id)) {
                    ledger_masters.push({ ..._, checked: false });
                }
            });
            ledger_masters = ledger_masters.map(_ => {
                let gstin_ledger = gstin_ledger_masters.find(__ => _.id == __.id || (_.ledger_analysis && _.ledger_analysis.id == __.id));
                if(gstin_ledger) {
                    return {
                        ..._,
                        last_sync_date: gstin_ledger.last_sync_date,
                        data_source_type: gstin_ledger.data_source_type,
                        future_dated_credit_amount: gstin_ledger.future_dated_credit_amount,
                        future_dated_debit_amount: gstin_ledger.future_dated_debit_amount,
                        avg_repayment_period: _.avg_repayment_period || gstin_ledger.avg_repayment_period
                    };
                }
                return _;
            });
            this.setState({
                status: STATE_STATUS.FETCHED,
                gstin: parsedGstin,
                ledger_masters
            });
        });
        
    }

    createCaseEntryRecord = async () => {
        const { company, caseDetail } = this.props;
        const { ledger_masters } = this.state;
        company && this.setState({
            caseEntryRecord: new CaseEntryRecord({
                company_name: company && company.name,
                type: caseDetail.case_type,
                business_product_type: caseDetail.business_product_type,
                program_type: caseDetail.program_type,
                gstin: company?.gstin,
                sales_manager_user_id: caseDetail.sales_manager_user && caseDetail.sales_manager_user.id,
                sales_manager_users: caseDetail.sales_manager_users && caseDetail.sales_manager_users.map(_ => _.id),
                previous_case_via_existing_limit: caseDetail.previous_case_via_existing_limit,
                parent_fi_movement_cases: caseDetail.parent_fi_movement_cases,
                child_fi_movement_cases: caseDetail.child_fi_movement_cases,
                priority: caseDetail.priority,
                lead_type: caseDetail.lead_type,
                product: caseDetail.product,
                sellers: caseDetail.sellers,
                proposed_limit: caseDetail.proposed_limit,
                primary_language: caseDetail.primary_language == 0?null:caseDetail.primary_language,
                secondary_language: caseDetail.secondary_language == 0?null:caseDetail.secondary_language,
                ledger_masters: ledger_masters.map(_ => {
                    if(!_.hasOwnProperty("checked")) {
                        return { ..._, checked: true };
                    }
                    return _;
                }),
                bank: caseDetail.bank
            }),
            status: STATE_STATUS.CREATED
        });
    };

    updateCase = () => {
        this.formRef.current.validateFields((err, values) => {
            if(!err) {
                const {business_product_type, program_type, company_name, priority, sales_manager_user_id, bank, lead_type, ledger_masters, product, proposed_limit, sales_manager_users, type, previous_case_via_existing_limit, primary_language, secondary_language } = values;
                (!previous_case_via_existing_limit && type === 2) ? message.error("For Enhancement, Previous Case is mandatory") : this.props.updateCaseMeta(this.props.caseId, this.props.company.id, {
                    company_name, 
                    product: product && product.id,
                    sales_manager_user: sales_manager_user_id,
                    sales_manager_users: sales_manager_users,
                    parent_case_id: previous_case_via_existing_limit && previous_case_via_existing_limit.split("|")[0].split("-")[1].trim(),
                    case_type: type,
                    bank: bank && bank.id,
                    primary_language: primary_language,
                    secondary_language: secondary_language,
                    priority,
                    lead_type,
                    business_product_type: business_product_type,
                    program_type: program_type,
                    ledger_masters: (ledger_masters && ledger_masters.filter(_ => _.checked).map(_ => ({
                        ledger_analysis_id: (_.ledger_analysis && _.ledger_analysis.id) || null,
                        supplychain_id: _.supplychain_id || null
                    }))) || [],
                    proposed_limit,
                    sellers: values.sellers && values.sellers.map(_ => _.id),
                    is_term_loan_created_on_lms: this.props.caseDetail.is_term_loan_created_on_lms,
                }) && message.success("Updated Successfully");
            }
        });
    }


    renderProcessScreen() {
        if(this.props.caseId !== this.props.caseMeta.get("caseId") || this.state.status === STATE_STATUS.FETCHING) {
            return(
                <Col className={"w-100 h-100 pos-abs bg-white z-top"}>
                    Loading ...
                </Col>
            );
        } else if(this.props.caseMeta.get("status") === STATE_STATUS.UPDATING) {
            return(
                <Col className={"w-100 h-100 pos-abs bg-white z-top"}>
                    Updating ...
                </Col>
            );
        }
        return null;
    }

    submitForm = (values) => {
        this.props.uploadCompanyLedger(this.props.caseId, values);
        this.setState({
            openModal: false
        }, () => {
            // this.fetchLedgerMastersAndGSTIN();
        });
    }


    renderForm() {
        let disabledFields = ["type", "proposed_limit", "gstin"];
        if(![5, 7, 8, 20].includes(Number(this.props.stageId))) {
            disabledFields = [...disabledFields, "bank"];
        }
        if(this.state.status === STATE_STATUS.CREATED && [STATE_STATUS.IDLE, STATE_STATUS.UPDATED, STATE_STATUS.UPDATE_FAILED].includes(this.props.caseMeta.get("status"))) {
            return( 
                <React.Fragment>
                    <Col>
                        <CaseCreateForm stageId={this.props.stageId} caseId={this.props.caseId} values={this.state.caseEntryRecord} ref={this.formRef} disabledFields={disabledFields} mandatoryFields={["bank"]} type={"Update"} gstin={this.state.gstin} adminGroup={this.props.adminGroup} user_groups={this.props.user_groups}/>
                    </Col>
                    {/* <Col span={24}>
                        <Button type={"primary"} onClick={() => {
                            this.setState({
                                openModal: true
                            });
                        }}>{"Upload Ledger"}</Button>
                    </Col> */}
                    <Col span={24} className={"w-100 bg-white b-0 d-flex flex-row-reverse"}>
                        <Button type={"primary"} onClick={this.updateCase}> Update </Button>
                    </Col>
                </React.Fragment>
            );
        }
        return null;
    }
    


   
    render() {
        const { caseDetail, company } = this.props;
        if(!caseDetail || !company) {
            return null;
        }
        return(
            <React.Fragment>
                <Modal
                    visible={this.state.openModal}
                    onCancel={() => {
                        this.setState({
                            openModal: false
                        });
                    }}
                    closable={true}
                    width={820}
                    destroyOnClose={true}
                    footer={null}
                >
                    <UploadLedgerForm 
                        submitForm={this.submitForm}
                    />
                </Modal>
                <Drawer 
                    title={"Update Case Meta Info"}
                    closable
                    visible={!!this.props.caseId}
                    onClose={this.hideDrawer}
                    placement={"right"}
                    width={"80vw"}
                    className={"full-height-drawer"}
                    destroyOnClose={true}
                >
                    <Row className={"h-100"}>
                        {this.renderProcessScreen()}
                        {this.renderForm()}
                    </Row>
                </Drawer>
            </React.Fragment>
        );
    }
}

CaseMetaInfo.propTypes = {
    caseId: PropTypes.number,
    caseDetail: PropTypes.object,
    company: PropTypes.object,
    caseMeta: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    updateCaseMeta: PropTypes.func,
    resetCaseMeta: PropTypes.func,
    uploadCompanyLedger: PropTypes.func,
    uploadedLedgers: PropTypes.object,
    bankId: PropTypes.number,
    stageId: PropTypes.number,
    adminGroup: PropTypes.array,
    user_groups: PropTypes.array,
};

const mapStateToProps = (state, props) => {
    const { location: { state: locationState }} = props;
    const caseId = locationState && locationState.case_meta && locationState.case_meta.caseId;
    const caseDetail = state.caseDetails.getIn([caseId, "data"]);
    const bankId = state.caseDetails.getIn([caseId, "data", "bank", "id"]);
    const uploadedLedgers = state.caseDetails.getIn([caseId, "uploadedLedgers"]);
    const adminGroup = state.user.getIn(["data", "stage_admin"]);
    const user_groups = state.user.getIn(["data", "groups"]);
    const user = state.user.getIn(["data", "id"]);
    const current_case_task = state.caseDetails && 
        state.caseDetails.getIn([Number(caseId), "status"]) === "FETCHED" &&
        state.caseDetails.getIn([Number(caseId), "data"]).getCurrentCaseTask(user, adminGroup);
    const stageId = current_case_task && current_case_task.this_stage;
    let company = null;
    if(caseDetail) {
        company = state.companies.getIn([caseDetail.company, "data"]);
    }
    let caseMeta = state.caseMeta;
    return {
        caseId,
        caseDetail,
        company,
        caseMeta,
        uploadedLedgers,
        bankId,
        stageId,
        adminGroup,
        user_groups
    };  
};

const mapDispatchToProps = dispatch => bindActionCreators({
    updateCaseMeta,
    resetCaseMeta,
    uploadCompanyLedger
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CaseMetaInfo);